var map = {
	"./admin_signup.coffee": 2492,
	"./announcements.coffee": 2493,
	"./assignment_groups.coffee": 2494,
	"./assignments.coffee": 2495,
	"./calendar.coffee": 2496,
	"./canvas.coffee": 2497,
	"./course_files.coffee": 2498,
	"./courses.coffee": 2499,
	"./dissection_views.coffee": 2500,
	"./due_date_extensions.coffee": 2501,
	"./errors.coffee": 2502,
	"./grades.coffee": 2503,
	"./hello_coffee.coffee": 2504,
	"./home.coffee": 2505,
	"./launch.coffee": 2506,
	"./left_bar.coffee": 2441,
	"./left_bar.coffee.erb": 2441,
	"./live_search.coffee": 2507,
	"./lms.coffee": 2508,
	"./lms_info.coffee": 2509,
	"./mail_response.coffee": 2510,
	"./memory_stats.coffee": 2511,
	"./popup.coffee": 2512,
	"./quiz_questions.coffee": 2442,
	"./quiz_questions.coffee.erb": 2442,
	"./quizzes.coffee": 2513,
	"./rails_vars.coffee": 2443,
	"./rails_vars.coffee.erb": 2443,
	"./registration.coffee": 2444,
	"./registration.coffee.erb": 2444,
	"./registrations.coffee": 2514,
	"./tinymce_fix.coffee": 2445,
	"./tinymce_fix.coffee.erb": 2445,
	"./web_suite.coffee": 2515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2491;